export enum ClaimType {
  BodilyInjured="bodily-injured",
  PropertyDamage="property-damage",
  Both="both"
}
